export default function PHP_ping() {
  return (
    <div>
      <h1>PHP_ping</h1>
    </div>
  );
}
